const domainRegex = /^(?!-)(?!.*--)[A-Za-z0-9-]+(\.[A-Za-z0-9-]+)*(?<!-)(\.[A-Za-z]{2,})$/;
const emailAllowedLettersRegex = /^[A-Za-z0-9!#$%&'*+-/=?^_`{|}~.(),:;<>@[\]]*$/;

export const validateEmail = (value: string) => {
  if (!value) return true;
  if (!value.includes('@')) {
    return '「@」を含めて入力してください';
  }

  const [name, domain, ...tails] = value.split('@');

  if (!name) {
    return '「@」の前にユーザー名を入力してください';
  }

  if (tails.length > 0 || !domainRegex.test(domain)) {
    return '「@」に続く正しいメールアドレスの形式で入力してください';
  }

  return true;
};

export const testEmailAllowedLetters = (value: string) => {
  return emailAllowedLettersRegex.test(value);
};
